<script setup lang="ts">
import type { NuxtError } from '#app'
import Button from "./components/ui/button/Button.vue";
const { isAuthenticated } = useAuth();

const props = defineProps({
  error: Object as () => NuxtError
})
</script>

<template>
  <div>
  <NuxtLayout :name="isAuthenticated ? 'default' : 'unauthenticated'">
    <div class="container my-20 px-4 ">
      <p class="mb-8 text-lg text-stormcloud">
        {{ error.statusCode }} - {{ error.statusMessage }}
      </p>
      <Button variant="primary" as-child>
        <NuxtLink to="/">Return to the homepage</NuxtLink>
      </Button>
    </div>
  </NuxtLayout>
  </div>
</template>

<style scoped>

</style>